<template>
    <div class="box">
        <div class="tabbar" v-if="tabbarShow" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logoBlack.png" alt="" />
            <div class="downloads" @click="downloadApp">
                下载APP
            </div>
        </div>
        <img class="banner" src="/activity/goldinterprise/banner.png" alt="" />
        <img class="wapbanner" src="/activity/goldinterprise/wap/banner.png" alt="" />
        <div class="floatbox" v-if="showFloat">
            <img class="close" @click="showFloat = false" src="/activity/goldinterprise/close.png" alt="">
            <img src="/activity/goldinterprise/float.png" alt="">
            <div class="codeBoxs">
                <canvas class="canvasCode" ref="qrcodeCanvas"></canvas>
            </div>
        </div>
        <div class="content">
            <div class="part">
                <div class="part3">
                    <div class="contents">
                        <div class="login">
                            <div class="tp">
                                <span>15周年庆签到处 <span class="weight">领588元人民币红包</span></span><span class="rule"
                                    @click="controlPop = true">活动规则</span>
                            </div>
                            <div class="loginbox" ref="targetTops">
                                <div class="login-flex">
                                    <div class="interactive">
                                        <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号"
                                            @blur="changePhone" />
                                        <div class="codeBox">
                                            <input v-model="form.code" type="text" placeholder="请输入验证码" />
                                            <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                                            <span v-else>重新获取({{ verSecond }})</span>
                                        </div>


                                    </div>
                                    <div class="buttoms1 flex" @click="submit(form)">
                                        0元注册 炒黄金
                                    </div>
                                </div>
                                <div v-if="controlImgCodeDialog" class="codeDialog">
                                    <img :src="imgcodelocal" alt="" />
                                    <p>
                                        <span>图形验证码:</span>
                                        <input type="text" v-model="form.codeNumber" />
                                    </p>
                                    <div>
                                        <button @click="() => {
                                            this.controlImgCodeDialog = false;
                                        }
                                        ">
                                            取消
                                        </button>
                                        <button @click="confirm(form.codeNumber)">确定</button>
                                    </div>
                                </div>
                            </div>
                            <p class="tips">现在完成注册，除参与正常新人注册福利外，可额外获得588元人民币红包

                            </p>
                        </div>
                        <img class="partbox partboxs" src="/activity/goldinterprise/cart.png" alt="">

                    </div>


                </div>

                <div class="part4">
                    <div class="contents">
                        <img class="partbox" src="/activity/goldinterprise/cart1.png" alt="">

                        <div class="button-box flex">
                            <img class="button2" @click="tosCroll" src="/activity/goldinterprise/button2.png" alt="">
                            <img class="button" @click="tosCroll" src="/activity/goldinterprise/button1.png" alt="">

                        </div>
                    </div>


                </div>

                <div class="part5">
                    <div class="contents">

                        <img class="title" src="/activity/goldinterprise/title.png" alt="">
                        <img class="partbox" src="/activity/goldinterprise/cart2.png" alt="">
                        <div class="button-box flex">
                            <img class="button2" @click="tosCroll" src="/activity/goldinterprise/button3.png" alt="">
                            <img class="button" @click="tosCroll" src="/activity/goldinterprise/button1.png" alt="">

                        </div>
                    </div>

                </div>
            </div>
            <contactus-vue></contactus-vue>

        </div>
        <div class="wapcontent">
            <div class="part">
                <div class="part1">
                    <div class="waplogin">
                        <div class="tp">
                            <span>15周年庆签到处 <span class="weight">领588元人民币红包</span></span>
                            <span class="rule" @click="controlPop = true">活动规则</span>
                        </div>
                        <div class="login-flex">
                            <div class="interactive" ref="targetTops">
                                <input v-model="form.phone" ref="inputElement" type="text" placeholder="请输入手机号"
                                    @blur="changePhone" />
                                <div class="codeBox">
                                    <input v-model="form.code" type="text" placeholder="请输入验证码" />
                                    <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                                    <span v-else>重新获取({{ verSecond }})</span>
                                </div>

                                <div class="buttoms1 flex" @click="submit(form)">
                                    0元注册 炒黄金
                                </div>
                                <p class="tips">现在完成注册，除参与正常新人注册福利外，可额外获得588元人民币红包

                                </p>
                            </div>
                        </div>
                        <div v-if="controlImgCodeDialog" class="codeDialog">
                            <img :src="imgcodelocal" alt="" />
                            <p>
                                <span>图形验证码:</span>
                                <input type="text" v-model="form.codeNumber" />
                            </p>
                            <div>
                                <button @click="() => {
                                    this.controlImgCodeDialog = false;
                                }
                                ">
                                    取消
                                </button>
                                <button @click="confirm(form.codeNumber)">确定</button>
                            </div>
                        </div>

                    </div>
                    <div class="conts">
                        <img src="/activity/goldinterprise/wap/cart.png" alt="">

                    </div>
                </div>

                <div class="part3">
                    <div class="cons">
                        <img src="/activity/goldinterprise/wap/cart1.png" alt="">
                        <div>
                            <img src="/activity/goldinterprise/wap/button3.png" class="button" @click="tosCrolls"
                                alt="">
                            <img src="/activity/goldinterprise/wap/button1.png" class="button" @click="tosCrolls"
                                alt="">

                        </div>

                    </div>
                </div>

                <div class="part3 part4">
                    <div class="cons">
                        <img src="/activity/goldinterprise/wap/title.png" alt="">
                        <img src="/activity/goldinterprise/wap/cart2.png" alt="">
                        <div>
                            <img src="/activity/goldinterprise/wap/button2.png" class="button" @click="tosCrolls"
                                alt="">
                            <img src="/activity/goldinterprise/wap/button.png" class="button" @click="tosCrolls" alt="">

                        </div>

                    </div>


                </div>
            </div>
            <contactus-vue></contactus-vue>

        </div>

        <!-- 登录注册 -->
        <el-dialog :visible.sync="loginDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs">
            <div class="loginDialogs">
                <img class="closer" @click="loginDialog = false" src="/activity/Millionsubsidy/close.png" alt="" />
                <img class="success" src="/activity/Millionsubsidy/success.png" alt="">
                <div class="conts">
                    <span>您的账号：{{ account }}</span><br />
                    <span>密码：{{ password }}</span>
                </div>
                <div class="buttoms">
                    <img @click="toActivity" v-if="isApp" src="/activity/Millionsubsidy/wap/activity.png" alt="">
                    <img @click="downloadApp" v-else src="/activity/Millionsubsidy/download.png" alt="">
                    <img @click="loginDialog = false" src="/activity/Millionsubsidy/button1.png" alt="">

                </div>
            </div>
        </el-dialog>
        <!-- 活动规则 -->
        <div class="popup" v-if="controlPop">
            <span @click="closePop" class="closer1">X</span>
            <ul class="popContent">
                <li class="top-tit">
                    十五载星河同耀，首签臻享 588 元现金 超多豪礼接踵而至
                </li>

                <li>
                    <span>活动周期：</span>
                    即日起一{{ getLastDayOfMonth() }}

                </li>
                <li>
                    <span>第一阶段 | 注册即享双重礼</span><br />

                    现金奖励：新用户注册成功，即可领取 588 元人民币，在【平台—我的钱包】查看。<br />

                    交易助力：同步获赠 588 美元交易赠金，在【平台—我的—赠金奖励】查看。

                </li>
                <li>
                    <span>第二阶段 | 激活无限权益</span><br />

                    轻松解锁：首次入金激活账户后，588 元人民币将转入交易账户，完成 7 天内 ≥3手有效交易，即可将该资金自由提取或继续交易，无任何限制。<br />

                    额外加码：首入后享入金即送等额赠金，仅限新户，入金越多，赠金越高，有效降低交易成本、放大收益空间。

                </li>
                <!-- <li>
                    <span>第三阶段 | 独家保障 · 7日亏损全额补贴</span><br />
                    首入金额 ≥200 美金，即可解锁高阶福利，在 7 天内享亏损全额补贴，名额有限，仅前1000名可参加。<br />
                    有效期内累计亏损达到补贴额度，平台将补足对应现金。
                </li> -->
                <li>
                    <span>温馨提醒：</span>
                    7天内未完成要求且未提现成功，588 元现金将被回收，其余权益不受影响。
                </li>

                <li>

                    <table>
                        <tr>
                            <th>层级</th>
                            <th>7日亏损</th>
                            <th>交易补贴额度</th>

                        </tr>
                        <tr>
                            <th>L1</th>
                            <th>≥$100</th>
                            <th>$50现金+$50赠金</th>
                        </tr>
                        <tr>
                            <th>L2</th>
                            <th>≥$1000</th>
                            <th>$500现金+$500赠金</th>
                        </tr>
                        <tr>
                            <th>L3</th>
                            <th>≥$10000</th>
                            <th>$5000现金+$5000赠金</th>
                        </tr>

                    </table>
                </li>
                <li>
                    <span>补贴规则</span><br />
                    现金与赠金在达标 7 日后自动发放至账户余额。<br />

                    获得的现金可当真实资金使用，可交易可提现，提现无手数限制。<br />

                    补贴仅限领取一次，不可重复获取。<br />
                </li>
                <li>
                    <span>注意事项</span><br />
                    1. 参加原新用户活动的客户，无法重复参加该活动；<br />

                    2. 同一真实交易账户不可被多次邀请参加；<br />

                    3. 交易手数的计算：本活动只针对伦敦金伦敦银交易的手数计算，开仓一手再平仓一手，如此来回为一手；<br />

                    4.
                    若判定客户交易存在异常，例如恶意套利行为、短时间内如1分钟频繁进出经平台审核后实属剥头皮交易...等，公司皆有权收回相应交易优惠，本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。<br />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { verifyImgCode, quickRegister } from '../../../../api/info'
import ContactusVue from "../../Contactus.vue";
import { queryConfigValue, getFakebonus } from '@/apis/common';
import userSign from '@/mixins/userSign';
import { mapState, mapActions } from "vuex";
import { setToken, getToken, deleteToken } from "../../../../utils/cookies.js";
import { generateQRCode } from "../../../../utils/tools";
import { getChannelInfo, getConfigurationValue } from "@/apis/common";
import { getActiveDomain } from '../../../../utils/IMEI'

export default {
    components: {
        ContactusVue

    },
    mixins: [userSign],
    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            slider: true,
            showDialog: false,
            formattedDateString: '',
            timer: null,
            qrCodeUrl: '',
            loginDialog: false,//注册成功弹框
            account: '',//账号
            password: '',//密码
            isApp: false,//是否App进入 
            form: {
                phone: '',
                code: '',
                codeNumber: '',
            },
            tabbarShow: true,
            isApp: false,
            controlPop: false,
            showFloat: true,
            androidUrl: '',//安卓下载地址
            iosUrl: '',//ios下载地址
        };
    },

    mounted() {

        const { origin } = window.location;
        const channel = sessionStorage.getItem('channel');
        console.log('下载地址-------------------', channel)
        let url = origin + '/subject/download?channel=' + channel
        const icon = require('../../../../static/index/hongshi.jpg')
        generateQRCode(url, this.$refs.qrcodeCanvas, icon)

        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })()
        };


    },
    destroyed() {

    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                // this.$router.push({
                //     name: "sc_2024wap",
                //     query: this.$route.query || {},
                // });
            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.tabbarShow = false

            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)

        }

        else {
           
        }
        const channel = sessionStorage.getItem('channel');
        this.getAndroidUrl(channel);
        this.getIosUrl()



    },
    methods: {
        // 下载APP
        downloads() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
                try {
                    window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
                } catch (error) {
                    window.open('https://apps.apple.com/cn/app/id1598072476');
                }
            } else { // 安卓
                try {
                    window.android.gotoRegisterReal();
                } catch (error) {
                    window.open('https://oss.0790jiaxiao.com/HS/software/hs_9999.apk');
                }
            }
        },
        getLastDayOfMonth() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const lastDayOfMonth = new Date(year, month, 0);
            // 获取最后一天的日期
            const lastDate = lastDayOfMonth.getDate();
            return month + '月' + lastDate + '日'
        },
        confirm(attr) {
            if (attr) {
                let data = {
                    Mobile: this.form.phone,
                    Token: this.guid,
                    ImgCode: Number(attr),
                }
                // 获取图片验证码接口
                verifyImgCode(data).then(res => {
                    if (res.IsSuccess) {
                        this.$message({
                            message: res.Data,
                            type: 'success'
                        });
                        // this.form.code = res.data;
                        this.verControl = !this.verControl;
                        this.controlImgCodeDialog = false;
                    } else {
                        this.$message({
                            message: res.Data,
                            type: 'warning',
                        });
                        this.controlImgCodeDialog = false;
                    }
                })
            } else {
                this.$message({
                    message: '请输入图片验证码结果!',
                    type: 'warning'
                });
            }
        },
        // 前往活动
        toActivity() {
            if (this.$route.query) {
                if (this.$route.query.accessKey) {
                    window.open(window.location.origin + '/activity/MillionsubsidyDetail/index')
                } else {
                    // 在安卓app
                    if (window.android) {
                        window.android.gotoLogin();
                        return
                    }
                    // 在ios
                    if (window.webkit) {
                        window.webkit.messageHandlers.gotoLogin()
                        return
                    }
                }
            }
        },
        showDialogs() {
            this.controlPop = true

        },
        closePop() {
            this.controlPop = false
        },



        // 点击获取焦点
        focusInput() {
            this.$refs.inputElement.focus();
        },

        // 返回上级页面
        goback() {
            window.location.href = window.location.origin;
        },
        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            if (this.scroll > 90) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }
        },
        // 提交手机号验证码
        submit(form) {
            if (form.phone && form.code) {
                this.handleRegister().then((res) => {
                    console.log('注册信息------', res)
                    this.loginDialog = true

                    localStorage.setItem('token', res.Token);
                    localStorage.setItem('account', res.account);
                    this.account = res.account
                    this.password = res.password
                }).catch(() => {
                })
            } else {
                this.$message({
                    message: '请输入手机号和验证码！',
                    type: 'warning',
                });
            }
        },
        // 回到顶部
        toTop() {
            document.documentElement.scrollTop = 0;
        },
        // 跳转到登录注册
        tosCroll() {

            const targetElements = this.$refs.targetTops;
            const targetPosition = targetElements.offsetTop
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },
        tosCrolls() {

            const targetElements = this.$refs.targetTops;
            const targetPosition = targetElements.offsetTop + 300
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },

        // 客服链接
        live800() {
            window.open(
                this.$parent.live800Url
            );
        },
        // 下载App
        downloadApp() {
            var u = navigator.userAgent;
            if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
              
                    window.open(this.iosUrl);
                
            } else { // 安卓
                
                    window.open(this.androidUrl);
                
            }
        },

        //获取ios下载链接
        async getIosUrl() {
            const res = await getConfigurationValue({ key: 'IOSDownLoadLinkMT5' })
            console.log(res, 11111)
            if (res) {
                this.iosUrl = res

            }
        },
        //获取Android下载链接
        async getAndroidUrl(code) {
            const Rhref = window.location.host;

            if (Rhref.indexOf('rlchltd') > -1) {
                this.androidUrl = 'https://gdown.baidu.com/appcenter/pkg/upload/5e8443261199eb26beca3d0ae105ccaa'
            } else {
                const res = await getChannelInfo(code)
                console.log('下载地址----------', res)
                const { downloadUrl } = res;
                this.APKurl = downloadUrl || '';
                const { origin } = window.location;
                const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
                if (absoluteURLRegex.test(downloadUrl)) {
                    this.androidUrl = downloadUrl
                } else {
                    this.androidUrl = origin + '/' + downloadUrl
                }
            }

        },



    },
    deactivated() {
        clearInterval(this.animate)
    },
    beforeDestroy() {
        clearInterval(this.animate)
    },

};
</script>

<style lang="less" scoped>
.box {
    width: 100%;
    // overflow-x: hidden;
    // height: 6215px;

    position: relative;

    .tabbar {
        width: 100%;
        padding: 0 10%;
        box-sizing: border-box;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: space-between;

        img {
            margin: 20px 50px;
            width: 130px;
        }

        .downloads {
            width: 167px;
            height: 50px;
            border-radius: 20px;
            background: #ff0909;
            text-align: center;
            line-height: 50px;
            color: #fff;
            font-weight: 600;
            cursor: pointer;
        }
    }


    .navBarFixed {
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;

        display: block;
    }



    .wapbanner {
        width: 100%;
        display: none;
    }

    #login {
        width: 30%;
        height: 20vw;
        margin: 0 auto;
        background: url(/activity/firstsignature/bg1.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 10px;
        padding: 132px 0 58px;
        position: absolute;
        top: 2vw;
        right: -2%;
        transform: translate(-50%, 0);
        display: block;



    }





    .logins {
        position: absolute;
        top: 9%;
    }

    .floatbox {
        position: fixed;
        top: 50%;
        right: 0;
        width: 280px;
        height: auto;
        z-index: 12;
        .close{
            width: 30px;
            height: 30px;
            float: right;
            margin-right: 10px;
            cursor: pointer;
        }

        img {
            width: 100%;

        }

        .codeBoxs {
            position: absolute;
            top: 30%;
            left: 30%;

            .canvasCode {
                width: 120px;
                height: 120px;
            }

        }

    }


    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;

        background-size: 100% 90%;
        background: linear-gradient(to bottom, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1)10%, #F8E8C8 11%, #F8E8C8 100%);
        display: block;


        .part {
            // max-width: 1400px;

            margin: 0 auto;

            .part3 {
                background: url(/activity/goldinterprise/bg.png) no-repeat;
                background-size: 100% 100%;
                width: 100%;
                margin: 0 auto;
                position: relative;

                .login {
                    position: absolute;
                    top: -6%;
                    width: 1200px;
                    margin: 0 auto;
                    box-sizing: border-box;

                    background: url(/activity/goldinterprise/login.png) no-repeat;
                    background-size: 100% 100%;
                    padding: 80px 50px 50px;

                    .tp {
                        background: #fffdf5;
                        border-radius: 20px;
                        width: 100%;
                        height: 110px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 46px;

                        span {
                            font-weight: 600;
                        }

                        .weight {
                            color: #ed3714;
                            margin: 0 40px;
                        }

                        .rule {
                            color: #d1956b;
                            font-size: 22px;
                            text-decoration: underline;
                            cursor: pointer;
                        }
                    }

                    .login-flex {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        margin-top: 36px;

                    }


                    .interactive {
                        width: 70%;
                        display: flex;

                        justify-content: space-between;
                        align-items: center;

                        input:focus {
                            outline: none;
                        }

                        input {
                            width: 80%;
                            height: 3vw;
                            background: #fff4e5;
                            border: 1px solid #fff;
                            border-radius: 10px;
                            font-size: 16px;
                            text-indent: 25px;
                            list-style: none;
                            border: 1px solid #feb869;
                            // color: #ffb180;
                        }

                        .codeBox {
                            width: 80%;
                            position: relative;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin: 0 40px;


                            input {
                                width: 100%;
                            }

                            span {
                                width: 160px;
                                height: 3.2vw;
                                line-height: 3.2vw;
                                font-size: 16px;
                                border-radius: 10px;
                                background: linear-gradient(to bottom, #ffefcc, #ffc994);
                                width: 142px;

                                background: #ee2d07;

                                text-align: center;
                                color: #fff;
                                position: absolute;
                                top: 0vw;
                                right: 0px;
                                cursor: pointer;
                            }
                        }

                        .loginBtn {
                            width: 20%;
                            cursor: pointer;
                            position: relative;
                            top: 15px;
                        }
                    }

                    .codeDialog {
                        width: 500px;
                        height: 250px;
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background-color: #fee6e4;
                        border-radius: 15px;
                        z-index: 99;
                        border: 1px solid #ffdbdb;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;

                        img {
                            width: 120px;
                            margin-bottom: 0;
                        }

                        p {
                            span {
                                color: #5f0e15;
                                font-size: 18px;
                                font-weight: 600;
                            }

                            input {
                                width: 150px;
                                height: 30px;
                                background-color: #ffffff;
                                border: none;
                                margin-left: 10px;
                                text-indent: 10px;
                                color: #5f0e15;
                                font-size: 16px;
                            }
                        }

                        div {
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            button {
                                width: 100px;
                                height: 40px;
                                border: 1px solid #f64b44;
                                background-color: #ffffff;
                                color: #f64b44;
                                font-size: 18px;
                                border-radius: 8px;
                                margin: 0 10px;
                            }

                            button:nth-child(2) {
                                background-color: #f64b44;
                                color: #ffffff;
                            }
                        }
                    }

                    .buttoms1 {
                        width: 300px;
                        height: 70px;
                        border-radius: 30px;
                        background: #ee2d07;
                        font-size: 24px;
                        color: #fff;
                        cursor: pointer;
                    }
                }

                .contents {
                    width: 1200px;
                    margin: 0 auto;
                }

               
                .partboxs {
                    margin: 30% 0 80px;
                }



            }

            .part4 {
                background: url(/activity/goldinterprise/bg1.png) no-repeat;
                background-size: 100% 100%;
                padding: 90px 0 86px;

                .contents {
                    width: 1200px;
                    margin: 0 auto;

                    .box {}

                    .button-box {
                        margin-top: 80px;
                    }

                    .button2 {
                        margin-right: 72px;
                    }
                }
            }

            .part5 {
                background: url(/activity/goldinterprise/bg2.png) no-repeat;
                background-size: 100% 100%;
                width: 100%;
                margin: 0 auto;
                padding: 90px 0 86px;

                .contents {
                    width: 1200px;
                    margin: 0 auto;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }

                .button-box {
                    margin-top: 80px;
                }

                .title {
                    margin-bottom: 88px;
                }

                .button2 {
                    margin-right: 72px;
                }



            }
        }
    }

    .flex {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .wapcontent {
        display: none;
        width: 100%;
        height: auto;

        margin: 0 auto;



        .part {
            width: 100%;
            box-sizing: border-box;
            margin: 0 auto;

            .part1 {
                width: 100%;
                margin: 0 auto;
                position: relative;
                background: url(/activity/goldinterprise/wap/bg1.png) no-repeat;
                background-size: 100% 100%;
                padding-bottom: 30px;
                padding-top: 60px;

                .conts{
                    width: 90%;
                    margin: 0 auto;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }


                .waplogin {
                    width: 86%;
                    height: auto;
                    margin: 0 auto;
                    background: url(/activity/goldinterprise/wap/login.png) no-repeat;
                    background-size: 100% 100%;
                    border-radius: 10px;
                    padding: 60px 20px 40px;

                    box-sizing: border-box;
                    margin-bottom: 30px;
                    margin-top: -150px;

                    .tp {
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        background: #fffdf5;
                        border-radius: 10px;
                        font-size: 16px;
                        font-weight: 600;
                        padding: 10px 0;
                        margin-bottom: 30px;
                        white-space: nowrap;

                        .weight {
                            color: #e34a3f;
                            font-weight: 600;
                        }

                        .rule {
                            color: #d1956b;
                            font-weight: none;
                            font-size: 14px;
                            text-decoration: underline;
                            margin-top: 10px;
                        }

                    }

                    .login-flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .interactive {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;

                        input:focus {
                            outline: none;
                        }

                        input {
                            width: 90%;
                            height: 40px;
                            background: #fff;
                            border: 1px solid #fff;
                            border-radius: 10px;
                            font-size: 16px;
                            text-indent: 25px;
                            list-style: none;

                            // color: #ffb180;
                        }

                        .codeBox {
                            width: 90%;
                            position: relative;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            margin: 16px 0 26px 0;

                            input {
                                width: 100%;
                            }

                            span {
                                width: 100px;
                                height: 44px;
                                line-height: 44px;
                                font-size: 16px;
                                border-radius: 10px;
                                background: linear-gradient(to bottom, #ffefcc, #ffc994);
                                width: 102px;

                                background: #ee2d07;

                                text-align: center;
                                color: #fff;
                                position: absolute;
                                top: 0vw;
                                right: 0px;
                                cursor: pointer;
                            }
                        }

                        .loginBtn {
                            width: 20%;
                            cursor: pointer;
                            position: relative;
                            top: 15px;
                        }
                    }

                    .codeDialog {
                        width: 500px;
                        height: 250px;
                        position: fixed;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        background-color: #fee6e4;
                        border-radius: 15px;
                        z-index: 99;
                        border: 1px solid #ffdbdb;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                        align-items: center;

                        img {
                            width: 120px;
                            margin-bottom: 0;
                        }

                        p {
                            span {
                                color: #5f0e15;
                                font-size: 18px;
                                font-weight: 600;
                            }

                            input {
                                width: 150px;
                                height: 30px;
                                background-color: #ffffff;
                                border: none;
                                margin-left: 10px;
                                text-indent: 10px;
                                color: #5f0e15;
                                font-size: 16px;
                            }
                        }

                        div {
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            button {
                                width: 100px;
                                height: 40px;
                                border: 1px solid #f64b44;
                                background-color: #ffffff;
                                color: #f64b44;
                                font-size: 18px;
                                border-radius: 8px;
                                margin: 0 10px;
                            }

                            button:nth-child(2) {
                                background-color: #f64b44;
                                color: #ffffff;
                            }
                        }
                    }



                }

                .buttoms1 {
                    width: 90%;
                    height: 52px;
                    border-radius: 30px;
                    background: #ee2d07;
                    font-size: 18px;
                    color: #fff;
                    cursor: pointer;
                }

                .tips {
                    width: 90%;
                    color: #ff7c24;
                    font-size: 14px;
                    font-weight: 600;

                    margin-bottom: 0;
                }



            }

            .part3 {
                width: 100%;
                margin: 0 auto;
                background: url(/activity/goldinterprise/wap/bg.png) no-repeat;
                background-size: 100% 100%;
                padding: 30px 0;
                position: relative;
                .cons{
                    margin: 0 auto;
                    width: 90%;
                }

                img {
                    width: 100%;
                    height: 100%;
               
                }

                .button {
                    width: 50%;
                    height: auto;

                }
            }
            .part4 {
               
                background: url(/activity/goldinterprise/wap/bg1.png) no-repeat;
                background-size: 100% 100%;
            }
        }
    }

    .closer {
        width: 25px;
        height: auto;
        position: fixed;
        top: 0%;
        right: 0;
        cursor: pointer;

        z-index: 9999;
    }



    .dark {
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 101;
    }

    .loginDialogs {
        .closer {
            position: absolute;
            top: 40px;
            right: 0px;
            width: 50px;
            height: 50px;
        }

        position: relative;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        /deep/ .el-dialog__body {
            background: rgba(0, 0, 0, 0.5);

            border: none !important;
            width: 332px !important;
            height: 150px !important;
        }

        .conts {
            width: 300px;
            height: 96px;
            background: #fff1df;
            border-radius: 10px;
            position: absolute;
            bottom: 30%;
            right: 26%;
            z-index: 99;
            color: #000;
            font-weight: 600;
            line-height: 30px;
            font-size: 24px;
            text-align: center;
            padding-top: 20px;
            box-sizing: border-box;
        }

        .buttoms {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 8%;
            bottom: 10%;
            width: 80%;
            cursor: pointer;

            img:nth-child(1) {
                margin-right: 20px;
            }

            img {
                width: 40%;
                height: auto;
            }
        }



    }

    .popup {
        overflow-x: hidden;
        width: 1100px;
        height: 900px;
        border-radius: 20px;
        background: #fdf5e6;
        position: fixed;
        top: 57%;
        left: 50%;
        transform: translate(-50%; -50%);
        box-sizing: border-box;
        padding: 10px;
        box-shadow: 0px 0px 95px 0px rgba(43, 53, 105, 0.1);
        overflow-y: scroll;
        padding-bottom: 40px;
        z-index: 99999999999999;

        .closer1 {
            float: right;
            cursor: pointer;
            margin-top: 8px;
            margin-right: 10px;
        }

        .popContent {
            box-sizing: border-box;
            padding: 40px 50px 20px;

            .top-tit {
                font-weight: 600;
                color: #000;
                font-size: 30px;
                margin-bottom: 30px;
            }

            li {
                font-size: 18px;
                color: #a86e4f;
                line-height: 36px;

                span {
                    font-weight: 600;
                    color: #e34a3f;
                }

                img {
                    width: 100%;
                    height: auto;
                    margin: 20px 0;
                }

                table {
                    border: 1px solid #e34a3f;
                    border-radius: 15px;
                    width: 100%;

                    tr {
                        th {
                            text-align: center;
                            font-weight: 500;
                            line-height: 50px;
                            border-bottom: 1px solid #d2a765;
                            border-right: 1px solid #d2a765;
                            padding: 5px;
                        }

                        th:last-child {
                            border-right: 1px solid transparent;
                        }
                    }

                    tr:nth-child(1) {
                        th {
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
}


@media screen and (max-width: 500px) {
    .box {
        .tabbar {
            width: 100%;
            padding: 0 5%;
            box-sizing: border-box;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                margin: 20px 0px;
                width: 100px;
            }

            .downloads {
                width: 83px;
                height: 30px;
                border-radius: 20px;
                background: #ff0909;
                text-align: center;
                line-height: 30px;
                color: #fff;
                font-weight: 600;
                cursor: pointer;
                font-size: 12px;
            }
        }

        .banner {
            display: none;
        }

        .wapbanner {
            display: block;
        }

        .content {
            display: none;
        }

        .wapcontent {
            display: block;
        }

        #login {
            display: none;
        }





        .floatbox {
            display: none;
        }

        .loginDialogs {
            .closer {
                position: absolute;
                top: 40px;
                right: 22px;
                width: 30px;
                height: 30px;
            }

            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .success {
                width: 400px;
                height: auto;
            }

            /deep/ .el-dialog__body {
                background: rgba(0, 0, 0, 0.5);

                border: none !important;
                width: 332px !important;
                height: 150px !important;
            }

            .conts {
                width: 200px;
                height: 55px;
                background: #fff1df;
                border-radius: 10px;
                position: absolute;
                bottom: 31%;
                right: 26%;

                z-index: 99;
                color: #000;
                font-weight: 600;
                line-height: 18px;
                font-size: 14px;
                text-align: center;
                padding-top: 10px;
                box-sizing: border-box;
            }

            .buttoms {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                right: 8%;
                bottom: 10%;
                width: 80%;
                cursor: pointer;

                img:nth-child(1) {
                    margin-right: 20px;
                }

                img {
                    width: 40%;
                    height: auto;
                }
            }



        }


        .popup {
            position: relative;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 95%;
            height: 480px;
            box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
            background-color: #fdf5e6;
            border-radius: 15px;
            overflow-y: scroll;
            z-index: 99999999;

            .closer1 {
                width: 16px;
                height: 30px;
                height: auto;
                position: absolute;
                top: 5px;
                right: 5px;
                font-size: 20px;
            }

            .popContent {
                box-sizing: border-box;
                padding: 10px;
                overflow: hidden;

                .top-tit {
                    font-size: 16px;
                    margin-top: 20px;

                }

                li {
                    font-size: 14px;
                    color: #a86e4f;
                    line-height: 24px;

                    span {
                        font-weight: 600;
                        color: #e34a3f;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }

                    table {
                        width: 100%;
                        border: 1px solid #e34a3f;
                        border-radius: 10px;

                        tr {
                            th {
                                text-align: center;
                                font-weight: 500;
                                line-height: 24px;
                                border-bottom: 1px solid #d2a765;
                                border-right: 1px solid #d2a765;
                                padding: 5px;
                            }

                            th:last-child {
                                border-right: 1px solid transparent;
                            }
                        }

                        tr:nth-child(1) {
                            th {
                                font-weight: 600;
                            }
                        }
                    }
                }
            }
        }





    }
}

@media screen and (min-width: 375px) {
    .box {



        .logins {
            position: absolute;
            top: 8%;
        }
    }

}

//--------------------------110----------------------
@media screen and (min-width: 1724px) and (max-width: 1897px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }
        }

        .content {
            .part {

                .part1 .partbox,
                .part2 .partbox,
                .part3 .partbox {
                    width: 94%;
                }

              

            }
        }



        .floatbox {
            width: 240px;
        }

        .popup {
            height: 800px;
        }


    }

}

// ---------------125%------------------
@media screen and (min-width: 1517px) and (max-width: 1724px) {
    .box {
        #login {
            .buttom {
                width: 240px;
                height: 54px;
                margin: 0 auto;

                img {
                    width: 100%;
                }

            }
        }

        .content {
            .part {

               

            }
        }



        .floatbox {
            width: 240px;
        }


    }
}

// -------------------150%--------------
@media screen and (min-width: 1264px) and (max-width: 1517px) {
    .box {
        #login {
            height: 12vw;

            .login-flex {
                padding-top: 0;
            }

            .buttom {
                width: 180px;
            }

            .interactive {
                input {
                    font-size: 14px;
                }

                .codeBox {
                    span {
                        width: 92px;
                        font-size: 14px;
                    }
                }
            }
        }

        .content {
            .part {

               
            }
        }


        .floatbox {
            width: 200px;

            .codeBoxs {
                position: absolute;
                top: 24%;
                left: 30%;

                .canvasCode {
                    width: 90px;
                    height: 90px;
                }

            }
        }

    }
}
</style>